// @ts-nocheck
import {
    CategorySearchCollectionModel,
    getCategorySearchResults,
} from "@store/Framework/Services/CategorySearchService";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";
import { getContextData } from "@toolkit/Modules/client-framework/Store/Data/Pages/PagesActionCreators";

type LoadCategorySearchResultsParameter = {
    query: string;
};

type HandlerType = ApiHandler<LoadCategorySearchResultsParameter, CategorySearchCollectionModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        query: props.parameter.query.trim(),
    };
};

export const DispatchBeginLoadCategorySearchResults: HandlerType = props => {
    props.dispatch({
        type: "Data/Pages/BeginLoadPages",
        parameter: { categorySearch: true, query: props.apiParameter.query } as any,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getCategorySearchResults(props.apiParameter);
};

export const DispatchCompleteLoadCategorySearchResults: HandlerType = props => {
    const state = props.getState();

    props.dispatch({
        type: "Data/Pages/CompleteLoadPages",
        parameter: { categorySearch: true, query: props.apiParameter.query } as any,
        collection: {
            pages: [],
            pagination: {
                totalItemCount: props.apiResult?.totalItemCount ?? 0,
            } as any,
            properties: {
                items: props.apiResult?.items || [],
            },
        },
        links: state.links,
        ...getContextData(state),
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadCategorySearchResults,
    RequestDataFromApi,
    DispatchCompleteLoadCategorySearchResults,
];

const loadCategorySearchResults = createHandlerChainRunner(chain, "LoadCategorySearchResults");
export default loadCategorySearchResults;
